import Errors           from "../../../domain/fundamentals/message/error/Errors";
import ResKaReduxAction from "../ResKaReduxAction";

export enum ACTION_TYPE {
  ERROR_INIT = "ERROR_INIT",
  ERROR_SET = "ERROR_SET",
}

export interface ErrorInitAction extends ResKaReduxAction {
}

export interface ErrorSetAction extends ResKaReduxAction {
  errors: Errors;
}

export type ErrorAction = ErrorInitAction | ErrorSetAction;

export const errorInitAction = (): ErrorInitAction => ({
  type: ACTION_TYPE.ERROR_INIT,
});

export const errorSetAction = (errors: Errors): ErrorSetAction => ({
  type: ACTION_TYPE.ERROR_SET,
  errors: errors,
});